import { FrameName } from "../config";
import SmallHousesBuildingTileEntity from "./SmallHousesBuildingTileEntity";

class LargeHousesBuildingTileEntity extends SmallHousesBuildingTileEntity {
	public static readonly frameName = FrameName.LARGE_HOUSES;
}

export default LargeHousesBuildingTileEntity;
